import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { LocalizationService } from "./localization.service";
import { constants } from "../constants";
import { Language } from "../models/language.model";
import { Role } from "../models/role.model";
import { User } from "../models/user.model";

@Injectable({ providedIn: 'root' })
export class UserService {

  private static readonly CURRENT_USER_INFO_URL: string = `${constants.BASE_URL}/api/auth/current-user`;

  private user: User;
  private languages: Language[];

  constructor(
    private http: HttpClient,
    private router: Router,
    private localizationService: LocalizationService
  ) { }

  getCurrentUser(): void {
    this.http.get<any>(UserService.CURRENT_USER_INFO_URL).subscribe((currentUser: any) => {
      this.user = currentUser;
      if (this.hasSysTempRole()) {
        this.router.navigate(['/dashboard'], { queryParams: { cpa: this.user.userProfileList[0].value } });
      }
    });

    this.localizationService.getUserLanguages().subscribe((languages: Language[]) => {
      this.languages = languages;
      if (this.languages.length) {
        this.localizationService.updateLanguageSettings(this.languages[0]);
      }
    });
  }

  getLanguages(): Language[] {
    return this.languages;
  }

  getUserName(): string {
    return this.user?.last_name ? this.user.last_name : this.user?.email;
  }

  hasAdminRole(): boolean {
    return !!this.user?.roles?.find((role: Role) => role.name.toUpperCase() === 'DDD_ADMIN');
  }

  hasCountryAdminRole(): boolean {
    return !!this.user?.roles?.find((role: Role) => role.name.toUpperCase() === 'DDD_CTRY_ADMIN');
  }

  hasSysTempRole(): boolean {
    return !!this.user?.roles?.find((role: Role) => role.name.toUpperCase() === 'SYSTEM_TEMPORARY_USER');
  }

  hasUserRole(): boolean {
    return !!this.user?.roles?.find((role: Role) => role.name.toUpperCase() === 'DDD_USER');
  }

  isDddUser(): boolean {
    return this.hasAdminRole() || this.hasCountryAdminRole() || this.hasUserRole();
  }

}
